import React from 'react'
import { noop } from 'lodash'
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void
  variant?: 'primary' | 'secondary' | 'danger'
  size?: 'small' | 'medium' | 'large'
  disabled?: boolean
  width?: string
  isPaginationPage?: boolean
}

const disabledStyles = 'opacity-50 cursor-not-allowed'

const Button: React.FC<ButtonProps> = ({
  onClick = noop,
  className = '',
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  width,
  isPaginationPage,
  ...props
}: ButtonProps) => {
  const baseStyles = `${isPaginationPage ? '' : 'p-2.5'}`
  const sizeStyles = {
    small: `${isPaginationPage ? '' : 'text-xs py-2 px-4'}`,
    medium: 'text-base py-2 px-6',
    large: 'text-sm py-2 px-8',
  }
  const variantStyles = {
    primary: `rounded-lg ${width} bg-secondary-500 text-white hover:bg-secondary-600`,
    secondary: `rounded-lg ${width} bg-white text-accent-900`,
    danger: 'bg-error-500 text-white hover:bg-error-700 focus:ring-error-500',
  }
  const buttonStyles = `
    ${baseStyles}
    ${variantStyles[variant]}
    ${sizeStyles[size]}
    ${disabled ? disabledStyles : ''}
    ${className}
  `

  return (
    <button
      onClick={onClick}
      className={buttonStyles}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
